export default __webpack_public_path__ + "static/media/restore.c11f0ccf.png";